/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 09/11/21
 */

import React from 'react';
import { Td } from '@chakra-ui/react';
import { namedMemo } from '@/utils/namedMemo';

interface TableHeaderCellProps {
    title?: string;
}

const ChakraTableHeaderCell = namedMemo('ChakraTableHeaderCell', ({ title }: TableHeaderCellProps) => <Td>{title}</Td>);

export default ChakraTableHeaderCell;
